export default __webpack_public_path__ + "static/media/cross-fill.be72ee19.svg";